module.exports = __webpack_public_path__ + "static/media/creative-services-icon-selected.d2104de1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/creative-services-icon-selected.svg
// module id = 1925
// module chunks = 0